import { useIsReadOnlyMode } from "components/AnalysisRenderMode";
import ActionLink from "components/ActionLink";
import { useScenarioToolModal } from "./ScenarioToolModal";

export default function ScenarioToolLink({ farm, analysis }) {
    const isReadOnlyMode = useIsReadOnlyMode();
    const [scenarioToolModal, openScenarioToolModal] = useScenarioToolModal(farm, analysis);

    if (isReadOnlyMode)
        return null;

    return (
        <>
            <ActionLink id="scenario-tool" className="IconLink--wand u-font-green" onClick={openScenarioToolModal}>
                Scenario tool
            </ActionLink>
            {scenarioToolModal}
        </>
    )
}
